import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";

import {BmCardTitle} from "~/components/titles";
import {BmErrorButton, BmWhiteButton} from "~/components/buttons";

import {BaseModalProps, BmBaseModal} from "../../BaseModal";
import {BmBigTitleModalContent} from "../../contentTemplates/BigTitleModalContent";

export interface BmDeleteModalProps extends Omit<BaseModalProps, "title" | "footerButtons" | "ModalContentComponent"> {
  title: string;
  description?: string;
  buttonName?: string;
  onConfirm: VoidFunction;
  loading?: boolean;
}

export const BmDeleteModal: React.FC<BmDeleteModalProps> = ({
  title,
  description,
  buttonName,
  open,
  onConfirm,
  onClose,
  loading,
  bodySx,
  ...props
}) => {
  const {t} = useTranslation();

  return (
    <BmBaseModal
      open={open}
      onClose={onClose}
      title={<BmCardTitle>{title}</BmCardTitle>}
      bodySx={{width: "100%", maxWidth: "400px", ...bodySx}}
      ModalContentComponent={BmBigTitleModalContent}
      footerButtons={
        <>
          <BmErrorButton onClick={onConfirm} loading={loading}>
            {buttonName || t("buttons.delete")}
          </BmErrorButton>
          <BmWhiteButton onClick={onClose}>{t("buttons.cancel")}</BmWhiteButton>
        </>
      }
      {...props}
    >
      {description && <Typography variant="body0" component="div" dangerouslySetInnerHTML={{__html: description}} />}
    </BmBaseModal>
  );
};
